module.exports = __webpack_public_path__ + "img/icon_material_cumulative_hnt_1.fb1728ed.webp";